<template>
  <div class="image-upload">
    <div class="image-upload__input" v-if="!uploadedFile">
      <input class="hidden" type="file" @change="onFileSelected" accept="image/*" ref="fileInput">
      <button
        type="button"
        class="button button--add-new-section button--add-image"
        @click="$refs.fileInput.click()"
      >Add Image</button>
    </div>
    <div class="form__image" v-else>
      <img :src="`${imageUrl}`" :alt="`${fileName}`">
      <div class="form__image-remove">
        <button type="button" class="button button--remove" @click="deleteImage">&times;</button>
      </div>
    </div>
  </div>
</template>

<script>
//import axios from 'axios'
import firebase from "firebase";
export default {
    props: {
        imageName: String
    },
    data() {
        return {
            selectedFile: null,
            fileName: this.imageName,
            imageUrl: "",
            uploadedFile: this.imageName !== "" ? true : false
        };
    },
    created() {
        console.log(this.fileName, this.uploadedFile);
        if (this.imageName !== "") {
            this.getImage();
        }
    },
    methods: {
        onFileSelected(event) {
            this.selectedFile = event.target.files[0];
            this.fileName = this.selectedFile.name;
            this.uploadImage();
        },
        getImage() {
            let self = this;
            let storageRef = firebase.storage().ref();
            let pathReference = storageRef.child(self.fileName);

            pathReference.getDownloadURL().then(function(url) {
                self.imageUrl = url;
            });
        },
        uploadImage() {
            const fd = new FormData();
            const self = this;
            fd.append("image", this.selectedFile, this.selectedFile.name);
            /*axios
                .post(
                    'https://us-central1-recipe-app-475a9.cloudfunctions.net/uploadFile',
                    fd,
                    {
                        onUploadProgress: uploadEvent => {
                            console.log(
                                'Upload Progress: ',
                                Math.round(
                                    (uploadEvent.loaded / uploadEvent.total) *
                                        100
                                ) + '%'
                            )
                        },
                    }
                )
                .then(res => {
                    console.log(res)
                    self.uploadedFile = true
                    this.updateImageName()
                    console.log(self.uploadedFile)
                    self.getImage()
                })*/

            let storageRef = firebase.storage().ref();
            let task = storageRef
                .child(self.fileName)
                .put(self.selectedFile)
                .then(function(snapshot) {
                    snapshot.ref.getDownloadURL().then(function(url) {
                        self.uploadedFile = true;
                        self.imageUrl = url;
                        self.$emit("updateImageData", self.fileName);
                    });
                });
            /*storageRef.put(fd).then(function(snapshot) {
            })*/
        },
        deleteImage() {
            const self = this;
            let storageRef = firebase.storage().ref();
            let pathReference = storageRef.child(self.fileName);

            pathReference
                .delete()
                .then(function() {
                    console.log("deleted image");
                    self.fileName = "";
                    self.imageUrl = "";
                    self.uploadedFile = false;
                    self.$emit("updateImageData", self.fileName);
                    //self.removeImage()
                })
                .catch(function(error) {
                    console.log("ERROR: could not delete image", error);
                });
        }
    }
};
</script>

<style>
.hidden {
    display: none;
}

.image-upload {
    max-width: 200px;
    margin: 0 auto;
    text-align: center;
}
</style>